<!--Copy right - © 2024 tecera gmbh-->
<footer>
    Powered by 2kai
</footer>